import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
import Icon from '../icon';
const colors = {
  default: Colors.lightGray400,
  success: Colors.success400
};
const StyledContainer = styled.View`
  flex-direction: row;
  justify-content: flex-start;
`;
const StyledText = styled.View`
  align-self: center;
`;
const StyledWidth = styled.View`
  width: 14px;
`;
export default function Requirement(props) {
  const state = Object.keys(colors).includes(props.state) ? props.state : Requirement.defaultProps.state;
  return /*#__PURE__*/React.createElement(StyledContainer, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    name: "check-circle",
    color: colors[state],
    size: 20
  }), /*#__PURE__*/React.createElement(StyledWidth, null), /*#__PURE__*/React.createElement(StyledText, null, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    weight: "regular",
    color: Colors.gray600
  }, props.children)));
}
Requirement.defaultProps = {
  state: 'default',
  children: ''
};
Requirement.propTypes = {
  state: PropTypes.oneOf(Object.keys(colors)),
  children: PropTypes.node
};
//# sourceMappingURL=index.js.map